import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useArchNode from '../_ARCH/useArchNode.jsx'
import meta from './metaOa.mjs'
import PropertiesPane from './PropertiesPaneOa.jsx'
import api from './apiOa.mjs'

export default () => {
    const ArchNode = useArchNode()

    return extendNode(ArchNode, {
        ...meta,
        api,
        PropertiesPane,

        getStyle(map, node) {
            return this._getStyle(map, node, {
                backgroundColor: Color.LIGHT_YELLOW,
            })
        },

        _pushDataSlots: {
            archOmList: [],
        },
    })
}
